import { useRef } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import { Euler, Group, Quaternion } from 'three'
import { useXR, useXRInputSourceState, XROrigin } from '@react-three/xr'
import { computeFly, DEFAULT_FLY, type FlyConfig } from './logic'

const _q = new Quaternion()
const _e = new Euler()

export function Locomotion({ cfg = DEFAULT_FLY }: { cfg?: FlyConfig }) {
  const origin = useRef<Group>(null)
  const left = useXRInputSourceState('controller', 'left')
  const right = useXRInputSourceState('controller', 'right')
  const camera = useThree((s) => s.camera)
  const flyEnabled = useXR((s) => s.mode === 'immersive-vr')

  useFrame((_, delta) => {
    if (!flyEnabled || origin.current == null) return
    const ls = left?.gamepad['xr-standard-thumbstick']
    const rs = right?.gamepad['xr-standard-thumbstick']
    const input = {
      leftX: ls?.xAxis ?? 0,
      leftY: ls?.yAxis ?? 0,
      rightX: rs?.xAxis ?? 0,
      rightY: rs?.yAxis ?? 0,
    }
    camera.getWorldQuaternion(_q)
    const headYaw = _e.setFromQuaternion(_q, 'YXZ').y
    const { dPos, dYaw } = computeFly(input, headYaw, Math.min(delta, 0.1), cfg)
    origin.current.position.x += dPos[0]
    origin.current.position.y += dPos[1]
    origin.current.position.z += dPos[2]
    origin.current.rotation.y += dYaw
  })

  return <XROrigin ref={origin} />
}
